var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectricityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.stnone{display:none;}\n\t.st6{display:inline;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "stnone"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M4,23h19L12.9,7.7L4,23z M6.9,6.6H0v6.8h6.9V6.6z M19.8,9.5c2.3,0,4.2-1.9,4.2-4.2S22.1,1,19.8,1 s-4.2,1.9-4.2,4.2C15.5,7.6,17.4,9.5,19.8,9.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M7.8,20.3h8.5v-2.2H7.8V20.3z M12,0C7.2,0,3.4,3.8,3.4,8.5c0,4.2,3.5,8.2,7.4,8.2c0.1-0.2,0.7-4.8,0.7-4.8 H9.3l4.1-6.3l-0.7,5.5h1.8c0,0-2.6,5.4-2.6,5.5c4.3,0,8.8-4.1,8.8-8.2C20.6,3.8,16.8,0,12,0z M9.7,24h4.7v-2.2H9.7V24z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricityIcon);
export default __webpack_public_path__ + "static/media/electricity_icon.d844a880.svg";
export { ForwardRef as ReactComponent };